module.exports = __webpack_public_path__ + "static/media/apple_pay.3a18fe89.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/card-types/apple_pay.png
// module id = 565
// module chunks = 0